<template>
    <div class="container">
        <div class="container-content">
            <!-- 标题 -->
            <div class="container-content-title">钻探任务管理</div>
            <!-- 内容 -->
            <div class="content">
                <!-- 左侧统计 -->
                <div class="statistics">
                    <ConstructionTaskStatistics :teamList="teamList"></ConstructionTaskStatistics>
                </div>
                <!-- 右侧 -->
                <div class="data-list">
                    <ConstructionTaskTables :teamList="teamList"></ConstructionTaskTables>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <ViewBottom></ViewBottom>
    </div>
</template>
<script>
import ViewBottom from '../../../components/ViewBottom.vue'
import ConstructionTaskStatistics from './Components/ConstructionTaskStatistics.vue'
import ConstructionTaskTables from './Components/ConstructionTaskTables.vue'
import pubsub from 'pubsub-js'
import { GetUnitList } from '@/http/api/api-hb'
export default {
    components: { ViewBottom, ConstructionTaskStatistics, ConstructionTaskTables },
    data() {
        return {
            teamList: []
        }
    },
    mounted() {
        if (this.deptInfo && this.deptInfo.id) {
            this.requestTeamList()
        }
    },
    computed: {
        deptInfo() {
            return this.$store.state.unitInfo
        }
    },
    watch: {
        deptInfo() {
            this.requestTeamList()
        }
    },
    methods: {
        // 获取施工单位信息
        // requestConstructionInfo() {
        //     const user = JSON.parse(localStorage.getItem('user'))
        //     const params = {
        //         uid: this.deptInfo.id
        //     }
        //     GetConstructionInfo(params).then(res => {
        //         if (res.code == 200) {
        //             localStorage.setItem('dept', JSON.stringify(res.data))
        //             pubsub.publish('updateDeptInfo')
        //             this.requestTeamList(res.data.id)
        //         } else {
        //             this.$message.warning(res.msg)
        //         }
        //     })
        // },
        // 获取全部施工队
        requestTeamList() {
            GetUnitList({ pid: this.deptInfo.id }).then(res => {
                if (res.code == 200) {
                    this.teamList = res.data
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
    },
}
</script>
<style scoped>
    .container-content .content {
        width: 100%;
        height: calc(100% - 48px);
        display: flex;
    }
    .container-content .content .statistics {
        width: 403px;
        height: 100%;
        margin-right: 12px;
        /* background: #fff;
        border-radius: 6px; */
    }
    .container-content .content .data-list {
        width: calc(100% - 415px);
        height: 100%;
        background: #FFFFFF;
        border-radius: 6px;
    }
</style>